module.exports = require('./helpers/bundle-url').getBundleURL('6gjun') + "../images/verified.60f45a30..png" + "?" + Date.now();